import React, { useState, useEffect } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { getStudentProfileColumns } from '../utils/StudentProfileColumns';
import pallet from '../../../layouts/pallet';
import { getAllColumnsMappingOptions } from '../config/constant';
import { dataGridSx } from '../../common/styled/DataGrid';
import tableColumnUtils from '../../../utils/tableColumnUtils';
import { PageWrapper } from '../../common/styled';
import CustomDataGridToolbar from '../../common/components/CustomDataGridToolbar';

interface StudentProfilePageTableProps {
  selectedColumns: string[];
  studentProfileData: any;
  isLoading: boolean;
  onEdit?: (row: any) => void;
  school: string;
}

const StudentProfilePageTable: React.FC<StudentProfilePageTableProps> = ({
  selectedColumns,
  studentProfileData,
  isLoading,
  onEdit,
  school
}) => {
  const allColumns = getStudentProfileColumns(school, onEdit);

  const getVisibilityModelFromProps = () => {
    const visibilityModel: Record<string, boolean> = {};
    const columnOptions = getAllColumnsMappingOptions(school);
    allColumns.forEach((column) => {
      const matchingOption = columnOptions.find(
        (option) => option.label === column.headerName
      );

      if (matchingOption) {
        visibilityModel[column.field] = selectedColumns.includes(
          matchingOption.value
        );
      } else {
        visibilityModel[column.field] = column.field === 'actions';
      }
    });
    return visibilityModel;
  };

  const [columnVisibilityModel, setColumnVisibilityModel] = useState(
    getVisibilityModelFromProps()
  );

  useEffect(() => {
    setColumnVisibilityModel(getVisibilityModelFromProps());
    // eslint-disable-next-line
  }, [selectedColumns]);

  return (
    <PageWrapper sx={{ paddingTop: '16px !important' }}>
      <DataGrid
        rowHeight={50}
        rows={studentProfileData}
        columns={allColumns}
        loading={isLoading}
        disableRowSelectionOnClick
        pageSizeOptions={tableColumnUtils.PAGE_SIZE_OPTIONS}
        initialState={tableColumnUtils.DATA_GRID_INITIAL_STATE}
        showToolbar
        slots={{ toolbar: CustomDataGridToolbar }}
        slotProps={{
          toolbar: {
            printOptions: { disableToolbarButton: true },
            showQuickFilter: true
          }
        }}
        columnVisibilityModel={columnVisibilityModel}
        onColumnVisibilityModelChange={(newModel) =>
          setColumnVisibilityModel(newModel)
        }
        sx={{
          ...dataGridSx(pallet),
          '& .MuiDataGrid-virtualScroller': {
            overflowY: 'auto'
          }
        }}
      />
    </PageWrapper>
  );
};

export default StudentProfilePageTable;
